import { NgModule } from '@angular/core';
import { KURZANTRAG_CONFIG } from '@ebeihilfe/einreichung-old';
import { TranslateService } from '@ngx-translate/core';
import { EinreichungsConfirmationComponent } from '../config/einreichungs-confirmation.component';
import { getKurzantragConfig } from '../config/kurzantrag-config';
import { EinreichungOldModule } from './feature/einreichung';

@NgModule({
  declarations: [EinreichungsConfirmationComponent],
  providers: [
    {
      provide: KURZANTRAG_CONFIG,
      deps: [TranslateService],
      useFactory: getKurzantragConfig,
    },
  ],
  imports: [
    EinreichungOldModule.forRoot([
      EinreichungsConfirmationComponent,
    ]),
  ],
})
export class CustomerAppModule {
}
